import { useNuxtApp } from 'nuxt/app';
import type { Schema } from '~~/common/types/api';

type StartPopup = Schema<'PopupModel'>;

/** The `<source>` media of the start popup's `<picture>`: above it the desktop image is used. */
export function startPopupDesktopMedia () {
  return `(min-width: ${useNuxtApp().$styleVariables.breakpointMd})`;
}

/** The image `startPopupDesktopMedia` makes the browser pick for the current viewport. */
export function getStartPopupImage (popup: StartPopup) {
  return window.matchMedia(startPopupDesktopMedia()).matches
    ? popup.desktopImage
    : popup.mobileImage;
}
